export class CookieJar {

    /**
     * @type {Document}
     * @private
     */
    _document;

    /**
     * @param {?Document} doc
     */
    constructor(doc=null) {
        this._document = doc ? doc : window.document;
    }

    /**
     *
     * @param {string} key
     * @return {string}
     */
    get(key) {
        let name = key + "=";
        let ca = this._document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    /**
     * @param {string} key
     * @param {string} value
     * @param {number} expiresInDays
     */
    set(key, value, expiresInDays=undefined) {
        const d = new Date();
        expiresInDays = typeof expiresInDays !== "undefined" ? expiresInDays : 365;
        d.setTime(d.getTime() + (expiresInDays * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        this._document.cookie = key + "=" + value + ";" + expires + ";path=/";
    }

    /**
     * @param {string} key
     * @return {boolean}
     */
    has(key) {
        let value = this.get(key);
        return value !== "";
    }

}